import { render, staticRenderFns } from "./ConversionRates.vue?vue&type=template&id=4bb09bc7&scoped=true"
import script from "./ConversionRates.vue?vue&type=script&lang=ts"
export * from "./ConversionRates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb09bc7",
  null
  
)

export default component.exports